import { render, staticRenderFns } from "./UserLastMessage.vue?vue&type=template&id=2ce866e6"
import script from "./UserLastMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./UserLastMessage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports